import styles from './BootSplash.module.css';

/**
 * Full-screen hold while the startup restore (useBootstrapAuth) checks
 * the 30-day refresh cookie, so a still-valid session never flashes the
 * login form first. A tab with a saved session never sees it. Same shape
 * as the driver app's BootSplash, on the admin theme tokens.
 */
export function BootSplash() {
  return (
    <div className={styles.splash} role="status" aria-label="Restoring your session">
      <span className={styles.spinner} aria-hidden />
    </div>
  );
}
